import React from 'react';
import HostDetailHeader from './HostDetailHeader';
import HostDetailBody from './HostDetailBody';
import HostInfoJson from './HostInfoJson';
import KioskUpdateHistory from './KioskUpdateHistory';
import Sheldon from './Sheldon';
import Api from '../Api';
import Util from '../Util';
import { browserHistory } from 'react-router';
import * as actions from '../redux/actions';

class HostDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wanIPUrl: '',
      wanIPLocation: '',
      bodyView: 'overview',
    };
  }

  componentDidMount() {
/*
    // only 172 have the right wan/external ip because ip starts with 172 has router (fortinet 30D, 30E)
    if (/^172\./.test(ip)) {
      this.findLocationByExternalIP(externalIP);
    }
    this.setWanIPUrl(externalIP);
*/

    let paths = this.props.location.pathname.split('/');
    let bodyView = paths[paths.length - 1];
    if (/^(overview|json|update-history|sheldon)$/.test(bodyView)) {
      this.handleBodyViewChanged(bodyView);
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

/*
  setWanIPUrl(externalIP) {
    if (Util.isValidIpAddress(externalIP)) {
      this.setState({
        wanIPUrl: `http://www.infosniper.net/index.php?ip_address=${externalIP}&map_source=1&lang=1&map_type=1&zoom_level=7`
      });
    }
  }

  findLocationByExternalIP(externalIP) {
    if (Util.isValidIpAddress(externalIP)) {
      let promise = Api.getIPInfo(externalIP);
      promise.then(data => {
        if (this.unmounted) return;

        if (data.latitude && data.longitude) {
          // this.setState({externalIpInfoUrl: `https://www.google.com/maps?q=${data.latitude},${data.longitude}`})
        }
        if (data.results) {
          let addresses = data.results.map(obj => {
            return obj.formatted_address;
          });
          // console.log(addresses);
          if (addresses && addresses.length > 2) {
            let stateLevelInfo = addresses[addresses.length - 3];
            this.setState({wanIPLocation: stateLevelInfo});
          }
          else if (addresses && addresses.length > 1) {
            let stateLevelInfo = addresses[addresses.length - 2];
            this.setState({wanIPLocation: stateLevelInfo});
          }
          else if (addresses && addresses.length > 0) {
            let countryLevelInfo = addresses[addresses.length - 1];
            this.setState({wanIPLocation: countryLevelInfo});
          }
        }
        // console.log('ipfingerprints', data);
      })
    }
  }
*/

  handleBodyViewChanged(bodyView) {
    this.setState({ bodyView: bodyView }, () => {
      let hostInfo = this.props.hostInfo;
      if (hostInfo.id) {
        browserHistory.replace(`/id/${hostInfo.id}/${bodyView}`);
      }
    });
  }

  render() {
    let { bodyView } = this.state;

    // let {hostInfo, hostInfoListStatus} = this.props;
    // if (!hostInfo.ip && hostInfoListStatus.isLoading) {
    //   return (
    //     <div className="vertical-center">
    //       <h1>
    //         <i className="fa fa-refresh fa-spin"/><br/>
    //         loading...
    //       </h1>
    //     </div>
    //   )
    // }

    let bodyViewComp = null;
    switch (bodyView) {
      case 'sheldon':
        bodyViewComp = <Sheldon {...this.props} {...this.state} />;
        break;
      case 'json':
        bodyViewComp = <HostInfoJson {...this.props} state={this.state} />;
        break;
      case 'update-history':
        bodyViewComp = <KioskUpdateHistory {...this.props} state={this.state} />;
        break;
      default:
        bodyViewComp = <HostDetailBody {...this.props} {...this.state} />;
    }

    return (
      <div>
        <HostDetailHeader
          {...this.props}
          {...this.state}
          onBodyViewChange={this.handleBodyViewChanged.bind(this)}
        />
        {bodyViewComp}
      </div>
    );
  }
}

export default HostDetail;



// WEBPACK FOOTER //
// ./src/components/HostDetail.js